import { FETCH_EMPLOYEES, CLEAN_EMPLOYEES, DELETE_EMPLOYEE } from '../actions/types';

const EMPLOYEES_DEFAULT_STATE = {};

/**
 * Reducer pre zamestnancov.
 */
const EmployeesReducer = (state = EMPLOYEES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_EMPLOYEES:
            // Nacitanie zamestnancov
            return payload;

        case CLEAN_EMPLOYEES:
        case DELETE_EMPLOYEE:
            // Vytvorenie zamestnanca
            // Vycistenie zamestnancov
            // Zmazanie zamestnanca
            return EMPLOYEES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default EmployeesReducer;
